import * as React from 'react';
import Box from '@mui/material/Box';
import { Typography } from '@material-ui/core';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((_theme) => ({
  tooltipContainer: {
    display: "flex",
    padding: "5px",
  },
  icon: {
    margin: "0px 8px",
  },
  locationName: {
    fontSize: "14px !important",
    color: "#359DD0",
    fontWeight: "500 !important",
    fontFamily: 'Poppins, sans-serif',
  },
  plantName: {
    fontSize: "12px !important",
    color: "#404041",
    fontWeight: "500 !important",
    fontFamily: 'Poppins, sans-serif',
  },
}));

const ToolTipBox = styled(({ className, ...props }) => (
  <Box {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  color: 'rgba(0, 0, 0, 0.87)',
  borderRadius: "16px",
  fontSize: 11,
}));

export default function MapToolTip({ name, data, style }) {
  const classes = useStyles();
  const DC = data.filter((item) => item.LocationName === name);
  let path = window.location.pathname;

  return (
    <>
      {DC.map((item) => (
        <ToolTipBox style={style}>
          <div className={classes.tooltipContainer}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="17"
              viewBox="0 0 15 17"
              fill="none"
              className={classes.icon}
            >
              <path
                d="M3.42197 13.1465C2.01688 13.4628 1.11719 13.9488 1.11719 14.4937C1.11719 15.4469 3.86888 16.2195 7.26327 16.2195C10.6577 16.2195 13.4094 15.4469 13.4094 14.4937C13.4094 13.9488 12.5097 13.4628 11.1046 13.1465"
                stroke="#359DD0"
                strokeWidth="1.44049"
                strokeLinecap="round"
              />
              <path
                d="M9.18505 6.2312C9.18505 7.29195 8.32515 8.15185 7.2644 8.15185C6.20366 8.15185 5.34375 7.29195 5.34375 6.2312C5.34375 5.17045 6.20366 4.31055 7.2644 4.31055C8.32515 4.31055 9.18505 5.17045 9.18505 6.2312Z"
                stroke="#359DD0"
                strokeWidth="1.44049"
              />
              <path
                d="M8.23446 12.7566C7.97534 13.0062 7.62901 13.1457 7.26857 13.1457C6.90813 13.1457 6.56179 13.0062 6.30267 12.7566C3.92982 10.4574 0.749904 7.88889 2.30065 4.1599C3.13913 2.14367 5.15185 0.853516 7.26857 0.853516C9.38529 0.853516 11.398 2.14368 12.2365 4.1599C13.7853 7.88419 10.6132 10.4653 8.23446 12.7566Z"
                stroke="#359DD0"
                strokeWidth="1.44049"
              />
            </svg>
            <div>
              <Typography className={classes.locationName}>
                {item.Plant ? path === '/slp' ? item.Location : item.LocationName : ''}
              </Typography>
              <Typography className={classes.plantName}>
                {item.Plant ? `DC ${item.Plant}` : `Lane ${item?.LaneID}`}
              </Typography>
            </div>
          </div>
        </ToolTipBox>
      ))}
    </>
  );
}
